/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { fromCents, getCurrencyCode, getMinimumFractionDigits } from 'utils/helpers';
import InvoicesItem from 'components/Credit24/SelfService/Invoices/InvoicesItem';
import LateFeeAU from 'components/Credit24/SelfService/Invoices/LateFeeAU';

const propTypes = {
  unpaidInvoices: PropTypes.array.isRequired,
  contractId: PropTypes.string.isRequired,
  unpaidAmount: PropTypes.number.isRequired,
  lateFees: PropTypes.number,
};

const UnpaidInvoiceSection = ({
  unpaidInvoices, contractId, unpaidAmount, lateFees,
}) => {
  const showTotal = unpaidInvoices.length > 1 || (unpaidInvoices.length === 1 && lateFees > 0);
  const unpaidAmountInEuros = fromCents(unpaidAmount + lateFees);

  return (
    <>
      {unpaidInvoices.map((invoice) => (
        <InvoicesItem
          highlightAmount={!lateFees && unpaidInvoices.length === 1}
          key={invoice.id}
          invoice={invoice}
          contractId={contractId}
          showInvoiceNumber={COUNTRY !== 'AU'}
        />
      ))}
      {lateFees > 0
        && (
        <LateFeeAU
          amount={fromCents(lateFees)}
          highlightAmount={unpaidInvoices.length === 0}
        />
        )}
      {showTotal
        && (
        <div className="invoices txt-right">
          <div className="invoices__total invoices__total--type-warning">
            <FormattedMessage id="selfservice.invoices.total" />
            :&nbsp;
            <FormattedNumber
              style="currency"
              currency={getCurrencyCode()}
              value={unpaidAmountInEuros}
              minimumFractionDigits={getMinimumFractionDigits(unpaidAmountInEuros, 2)}
              maximumFractionDigits={2}
            />
          </div>
        </div>
        )}
    </>
  );
};

UnpaidInvoiceSection.propTypes = propTypes;

export default UnpaidInvoiceSection;
